module.exports = __webpack_public_path__ + "img/s1-img4.b36bb06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s1-img4.png
// module id = 404
// module chunks = 0